const ANIMATIONEND = 'animationend';
const $window = $(window);
const $document = $(document);
let $overlay; let $wrapper; let $content; let $loader; let $close;
const DATA_ATTRIBS_MAP = {
  'lite-info': 'info',
  'lite-width': 'width',
  'lite-height': 'height',
  'lite-resize': 'resize',
  'lite-noscroll': 'noscroll',
  'lite-root': 'root'
};
const idhash = {};
let liteboxLoaded = false;

function resizeImage(obj) {
  const ww = $window.width(); const wh = $window.height(); const
    $obj = $(obj);

  if (obj.originalWidth > ww) {
    $obj.css('max-width', 0.84 * ww);
  }
  else {
    $obj.css('max-width', 'none');
  }

  if (obj.originalHeight > wh - 60) {
    $obj.css('max-height', 0.84 * wh);
  }
  else {
    $obj.css('max-height', 'none');
  }
}

function setWidthHeight($elem, elem) { // from data attributes
  $elem.css({
    width: elem.options.width,
    height: elem.options.height
  });
}

function buildImage(obj) {
  const dfd = $.Deferred();
  const $img = $('<img />', { src: obj.elem.getAttribute('href') });

  $img.on('load', function() {
    if (obj.options.resize === true || Number(obj.options.resize) === 1 || obj.options.resize === 'yes') {
      this.originalWidth = this.width;
      this.originalHeight = this.height;
      resizeImage(this);
    }
    dfd.resolve(this);
  });

  setWidthHeight($img, obj);

  return dfd.promise();
}

function buildVideo(obj) {
  let href = obj.elem.getAttribute('href');

  if (href.indexOf('?') !== -1 && href.indexOf('wmode=transparent') === -1) href += '&wmode=transparent';
  if (href.indexOf('?') === -1 && href.indexOf('&') === -1 && href.indexOf('wmode=transparent') === -1) href += '?wmode=transparent';

  const $iframe = $('<iframe></iframe>', {
    src: href,
    width: obj.options.width,
    height: obj.options.height,
    frameborder: 0,
    allowfullscreen: true,
    mozallowfullscreen: true,
    webkitallowfullscreen: true
  });

  return $iframe;
}

function buildContent(obj) {
  const id = obj.elem.getAttribute('href').split('#')[1] || obj.elem.dataset.liteId;

  if (!id) return;

  let $obj = $(`#${id}`);
  const $iframes = $obj.find('iframe');

  if ($obj[0]) {
    idhash[id] = obj;
  }
  else {
    $obj = idhash[id].cachedContent;
  }

  if ($iframes.length > 0) {
    $iframes.each(function each() {
      let source = this.src;
      if (source.indexOf('?') !== -1 && source.indexOf('wmode=transparent') === -1) source += '&wmode=transparent';
      if (source.indexOf('?') === -1 && source.indexOf('&') === -1 && source.indexOf('wmode=transparent') === -1) source += '?wmode=transparent';
      if (this.src !== source) this.src = source;
    });
  }

  $obj.removeClass(obj.options.csshide);
  setWidthHeight($obj, obj);

  return $obj;
}

function Litebox(elem, options) {
  this.elem = elem;
  this.$elem = $(elem);
  this.timer = 0;

  let attrib;
  const dataAttribs = {};

  for (attrib in DATA_ATTRIBS_MAP) {
    if (typeof this.$elem.data(attrib) !== 'undefined') dataAttribs[DATA_ATTRIBS_MAP[attrib]] = this.$elem.data(attrib);
  }

  this.options = $.extend({}, $.fn.litebox.defaults, options, dataAttribs);
  this.init();
}

Litebox.prototype = {
  init() {
    const self = this;
    self.$root = $(self.options.root).length ? $(self.options.root) : $('body');
    if (!$overlay) self.stage();
    self.$elem.on('click.litebox-click', $.proxy(self.show, self));
  },

  enable() {
    this.$elem.on('click.litebox-click', $.proxy(this.show, this));
  },

  disable() {
    this.$elem.off('click.litebox-click');
  },

  stage() {
    const self = this;

    $overlay = $('<div />', { id: 'tlrk-overlay', class: self.options.csshide });
    $wrapper = $('<div />', { id: 'tlrk-litebox', class: self.options.csshide });
    $content = $('<div />', { class: (`litebox-content ${self.options.csshide}`) });
    $loader = $('<div />', { class: 'litebox-loader' }).html('Loading ...'); // html() is faster on empty div, than text()
    $close = $('<a />', { href: '#', class: 'litebox-close' }).html('&times;');

    // clicking on an element with .litebox-close-btn in the content will close the litebox
    $content.on('click', '.litebox-close-btn', e => {
      e.preventDefault();
      self.hide();
    });

    self.$root.append($overlay, $wrapper);
    $wrapper.append($content, $close);
  },

  populate() {
    const self = this;

    if (self.cachedContent === undefined) {
      $content.append($loader);

      if (self.options.info === 'image') {
        buildImage(self).done(img => {
          self.cachedContent = img;
          if (!self.opened) return;
          $content.html(self.cachedContent);
          self.appendTitle();
          if (self.options.center) self.center();
        });
      }
      else if (self.options.info === 'video') {
        self.cachedContent = buildVideo(self);
        $loader.remove();
        $content.html(self.cachedContent);
        self.appendTitle();
      }
      else if (self.options.info === 'content') {
        self.cachedContent = buildContent(self);
        $loader.remove();
        $content.html(self.cachedContent);
        self.appendTitle();
      }
    }
    else {
      if (self.options.info === 'image') resizeImage(self.cachedContent);
      $content.html(self.cachedContent);
      self.appendTitle();
    }
    if (self.options.center) self.center();
  },

  appendTitle() {
    const self = this;
    const title = self.elem.dataset.title;
    if (title) {
      const $p = $('<p />', { class: 'litebox-title' });
      $p.text(title);
      $content.append($p);
    }
  },

  destroy() {
    $content.empty();
  },

  show() {
    const self = this;
    self.opened = true;

    if (self.options.noscroll) self.$root.addClass('tlrk-litebox-noscroll');

    self.populate();

    $wrapper.add($close).removeClass(self.options.csshide);

    $overlay.removeClass(self.options.csshide).addClass(self.options.animIn);
    $content.removeClass(self.options.csshide).addClass(self.options.animInSec);

    if (self.options.center) self.center();

    // close
    $overlay.add($close).add($wrapper).one('click', $.proxy(self.hide, self));
    $content.on('click', e => {
      e.stopPropagation();
    });

    $document.on('keydown.litebox-keydown', e => {
      if (e.keyCode === 27 || (e.keyCode === 8 && !($(e.target).is('input') || $(e.target).is('textarea')))) {
        self.hide();
        e.preventDefault(); // ff and ie prevent .gif animation stop
      }
    });

    $window.on('resize.litebox-resize', () => {
      if (self.timer) clearTimeout(self.timer);
      self.timer = setTimeout($.proxy(self.resize, self), 150);
    });

    if (liteboxLoaded) {
      return false;
    }
  },

  hide() {
    const self = this;
    self.opened = false;
    $close.addClass(self.options.csshide);

    $overlay.removeClass(self.options.animIn).addClass(self.options.animOut);
    $content.removeClass(self.options.animInSec).addClass(self.options.animOutSec);

    $content.on(ANIMATIONEND, () => {
      if (self.options.noscroll) self.$root.removeClass('tlrk-litebox-noscroll');
      $overlay.removeClass(self.options.animOut).addClass(self.options.csshide);
      $content.removeClass(self.options.animOutSec).addClass(self.options.csshide);
      $wrapper.addClass(self.options.csshide);
      self.destroy();
      $content.off(ANIMATIONEND);
    });

    $document.off('keydown.litebox-keydown');
    $window.off('resize.litebox-resize');

    return false;
  },

  center() {
    $content.css({
      'margin-top': -($content.height() / 2),
      'margin-left': -($content.width() / 2),
      'margin-right': ($content.width() / 2)
    });
  },

  resize() {
    const self = this;
    resizeImage(self.cachedContent);
    if (self.options.center) self.center
  }
};

$.fn.litebox = function liteboxPlugin(options) {
  return this.each(function each() {
    if (!$.data(this, 'litebox')) $.data(this, 'litebox', new Litebox(this, options));
  });
};

$.fn.litebox.defaults = {
  info: 'image',
  animIn: 'fadeIn',
  animOut: 'fadeOut',
  animInSec: 'fadeInScale',
  animOutSec: 'fadeOutScale',
  csshide: '-dn',
  resize: true,
  noscroll: false,
  root: 'body',
  center: false
};

function bindEvent(el, eventName, handler) {
  if (el.addEventListener) {
    el.addEventListener(eventName, handler);
  }
  else if (el.attachEvent) {
    el.attachEvent(`on${eventName}`, () => {
      handler.call(el);
    });
  }
}

let timer = false;
const minDeviceWidth = 990;

function createInstances(options) {
  if (timer) {
    window.clearTimeout(timer);
    timer = false;
  }
  if ($window.width() >= minDeviceWidth && !liteboxLoaded) {
    $('.litebox').litebox(options);
    liteboxLoaded = true;
  }
  if ($window.width() < minDeviceWidth) {
    $(".litebox[data-lite-info='content']").litebox(options);
    liteboxLoaded = false;
  }
}

export function initialize(options) {
  createInstances(options);

  $.fn.litebox.defaults = {
    ...$.fn.litebox.defaults,
    ...options
  };

  bindEvent(window, 'resize', () => {
    if (!timer) {
      timer = window.setTimeout(() => createInstances(options), 1000);
    }
  });

  bindEvent(window, 'orientationchange', () => createInstances(options));
}
